<div odxLayout="flex gap-none" class="h-100 overflow-hidden flex-column">
  <app-project-detail-header
    [hideBackArrow]="hideBackArrow"
    [project]="project"
    (navigateBack)="navigateBack()"
  ></app-project-detail-header>

  @if ((isMobile$ | async) === false) {
    <odx-tab-bar [selectedIndex]="tabIndex" (selectedTabChanged)="tabIndex = $event.selectedIndex">
      @for (tab of desktopTabOrder; track tab.id) {
        <odx-tab-bar-item [attr.data-testid]="tab.testId">{{ tab.label }} </odx-tab-bar-item>
      }
    </odx-tab-bar>

    @for (tab of desktopTabOrder; track tab.id) {
      <div class="tab-content h-100" [hidden]="tabIndex !== $index">
        @switch (tab.id) {
          @case ("FLOORPLANS") {
            <app-floorplan-upload [projectData]="project"></app-floorplan-upload>
          }
          @case ("IMAGES") {
            <app-image-upload [projectData]="project"></app-image-upload>
          }
          @case ("FILES") {
            <app-files [projectData]="project"></app-files>
          }
          @case ("PRODUCT_LIST") {
            @if (monitoringProject) {
              <app-monitoring-product-list [project]="monitoringProject"></app-monitoring-product-list>
            } @else if (fgdsProject) {
              <app-product-list [projectData]="fgdsProject"></app-product-list>
            }
          }
          @case ("INFORMATION") {
            <app-project-information [projectData]="project"></app-project-information>
          }
          @case ("COLLABORATION") {
            <app-project-collaboration [projectData]="project" [isHidden]="tabIndex !== $index"></app-project-collaboration>
          }
          @case ("CHECKLIST") {
            @if (monitoringProject) {
              <app-checklist-monitoring [project]="monitoringProject"></app-checklist-monitoring>
            } @else if (fgdsProject) {
              <app-checklist [project]="fgdsProject"></app-checklist>
            }
          }
        }
      </div>
    }
  } @else {
    <div class="mobile-content tab-content h-100 overflow-hidden">
      @for (tab of mobileVisibleTabOrder; track tab.id; let i = $index) {
        <div class="tab-content h-100" [hidden]="tabIndex !== i">
          @switch (tab.id) {
            @case ("INFORMATION") {
              <app-project-information [projectData]="project"></app-project-information>
            }
            @case ("CHECKLIST") {
              @if (monitoringProject) {
                <app-checklist-monitoring [project]="monitoringProject"></app-checklist-monitoring>
              } @else if (fgdsProject) {
                <app-checklist [project]="fgdsProject"></app-checklist>
              }
            }
            @case ("IMAGES") {
              <app-image-upload [projectData]="project"></app-image-upload>
            }
            @case ("PRODUCT_LIST") {
              @if (monitoringProject) {
                <app-monitoring-product-list [project]="monitoringProject"></app-monitoring-product-list>
              } @else if (fgdsProject) {
                <app-product-list [projectData]="fgdsProject"></app-product-list>
              }
            }
            @case ("COLLABORATION") {
              <app-project-collaboration [projectData]="project" [isHidden]="tabIndex !== i"></app-project-collaboration>
            }
            @case ("FILES") {
              <app-files [projectData]="project"></app-files>
            }
          }
        </div>
      }
    </div>

    <app-mobile-bottom-nav
      [tabIndex]="tabIndex"
      [isReadOnlyUser]="(isReadOnlyUser$ | async) ?? false"
      [items]="mobileNavItems"
      (tabSelected)="tabIndex = $event"
    ></app-mobile-bottom-nav>
  }
</div>
